import { memo } from "react";

import OwnerAnimalSelect from "../../components/multiforms/OwnerAnimalSelect";

const Pedigree = () => {
    return (
        <OwnerAnimalSelect type={"Pedigree"} />
    )
};

export default memo(Pedigree)